import { useEffect, useState } from "react";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import {
  RowDataTypes,
  RowDataTypesMap,

} from "../types/RowDataTypes";
import { fetchRowDataErrorMessages as errorMessages } from "../../strings/errors";
import { showWarningAlert } from "../../helper/alerts";
import DataDisplayRowI from "../../DataDisplay/DataDisplayRowI";

export function useFetchRowData(
  itemsPerPage: number,
  currentPage: number,
  searched: string,
  filters: string[],
  changed: number,
  col: string = "createdAt",
  order: string = "ASC",
  rowDataType: RowDataTypes,
  dataDisplayRow: DataDisplayRowI,
  extraParams?: any,
) {
//   console.log(rowDataType);
//   console.log(currentPage);
//   console.log(itemsPerPage);

  const [data, setData] = useState<RowDataTypesMap[RowDataTypes][] | null>(
    null
  );
  const [totalRows, setTotalRows] = useState(0);
  const [itemsOnPage, setItemsOnPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    // console.log("fetched");
    // console.log(filters);
    // console.log(searched);
    let isMounted = true;
    setIsLoading(true);
    const abortController = new AbortController();

    async function fetchData() {
      let params: any = {
        limit: itemsPerPage,
        skip: (currentPage - 1) * itemsPerPage,
        signal: abortController.signal,
        filters: filters,
        searched: searched.trim(),
        col: col.toLowerCase(),
        order: order,
      };

      if (!(!extraParams))
        params = dataDisplayRow.generateParams!!(params, extraParams)

    //   console.log("the extras");
    //   console.log(col);
    //   console.log(order);
    //   console.log(params)

      let request: Promise<any>;
      if (dataDisplayRow.method === 'GET') {
        const { signal: _signal, ...queryParams } = params;
        request = axiosPrivate.get(dataDisplayRow.endpoint, {
          params: {
            ...queryParams,
            filters: JSON.stringify(queryParams.filters),
          },
          withCredentials: true,
        });
      } else {
        request = axiosPrivate.post(dataDisplayRow.endpoint, params, {
          withCredentials: true,
        });
      }

      await request
        .then((response) => {
          if (isMounted) {
            const initialData: RowDataTypesMap[RowDataTypes][] = [];
            response.data[dataDisplayRow.accessData].forEach((data: any) => {
              const rowData: RowDataTypesMap[RowDataTypes] =
                dataDisplayRow!!.create(data)
              initialData.push(rowData);
            });
            setTotalRows(response.data.count);
            setData(initialData);
            setItemsOnPage(response.data[dataDisplayRow.accessData].length);
            // console.log(response.data);
          }
        })
        .catch((error) => {
          if (!(!error) && !(!error.response) && !(!error.response.status) && error.response.status === 403) {
            showWarningAlert("Session Expired");
            return;
          }
          showWarningAlert(errorMessages[rowDataType]);
        });

      setIsLoading(false);
    }

    fetchData();

    return () => {
      isMounted = false;
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsPerPage, currentPage, changed]);
//   console.log(itemsOnPage);
  return {
    data: data,
    totalRows: totalRows,
    itemsOnPage: itemsOnPage,
    isLoading: isLoading,
  };
}

